import React from 'react';
import {observer} from 'mobx-react';
import * as util from '../../../util';
import s from '../../s';

declare var __fast_ship: boolean;

export const Header = observer(() => {
    const docSize = `${s.ui.doc_type} Size ${s.pcs.docWidth}"w x ${s.pcs.docHeight}"h`;

    return (
        <div
            id="prod-header"
            className="portal3"
        >
            {s.prod && s.si && (
                <div>
                    {(!s.si.ManualOverride_Desc || s.si.ManualOverride_Desc.length <= 5) && (
                        <h1>
                            {!s.prod.TitleShowInstName ? '' : `${s.si.InstName}`} - {s.ui.product_title}
                        </h1>
                    )}
                    {s.si.ManualOverride_Desc && s.si.ManualOverride_Desc.length > 5 && (
                        <h1>
                            {s.si.ManualOverride_Desc} - {docSize}
                        </h1>
                    )}
                </div>
            )}
            {s.ui.show_pricing && <span className="msrp-disc">{util.currency(s.ui.price === s.ui.price_discount ? s.ui.price : s.ui.price_discount)}</span>}

            {__fast_ship && s.isRetail && s.si && s.si.StoreTypeID !== 5 && s.__fast_ship_orig && s.PortalID === 3 && (
                <div className={`fast-ship-container-3`}>
                    <div>
                        <i className="fas fa-cart-shopping-fast"></i>
                    </div>
                    <div>
                        = SHIPS IN 2-3 DAYS
                    </div>
                </div>
            )}
        </div>
    );
});
